<template>
  <div class="pay-system_selection_wrapper">
    <div class="form_payment_action_pointer">
      <img class="form_payment_action_pointer__img" src="./arrow.png" alt="">
    </div>

    <div class="pay-system_choice">
      <div class="pay-system-type__header">Оплата с карты</div>
      <div class="pay-system-type_wrapper">
        <div class="pay-system-type_item_wrapper visa_mastercard" :class="isActive('AC')" @click="selectPaymentType('AC')" data-pay-system="yandex_kassa">
          <div class="pay-system-type_item_content">Банковские карты</div>
        </div>

        <div class="pay-system-type_item_wrapper sberpay" :class="isActive('SB')" @click="selectPaymentType('SB')" data-pay-system="yandex_kassa">
          <div class="pay-system-type_item_content">SberPay</div>
        </div>

        <div class="pay-system-type_item_wrapper cash" :class="isActive('GP')" @click="selectPaymentType('GP')" data-pay-system="yandex_kassa">
          <div class="pay-system-type_item_content">Наличными</div>
        </div>
      </div>

      <div class="pay-system-type__header">Электронные деньги</div>
      <div class="pay-system-type_wrapper electronic_money">
        <div class="pay-system-type_item_wrapper  qiwi" :class="isActive('QW')" @click="selectPaymentType('QW')" data-pay-system="yandex_kassa">
          <div class="pay-system-type_item_content">Qiwi</div>
        </div>

        <div class="pay-system-type_item_wrapper  yandex_dengi" :class="isActive('PC')" @click="selectPaymentType('PC')" data-pay-system="yandex_kassa">
          <div class="pay-system-type_item_content">ЮMoney</div>
        </div>
      </div>

      <div class="pay-system-type__header other_pay-system-type__header" @click ="otherTypes ? otherTypes = false : otherTypes = true"><span>Другие способы</span></div>
      <div class="pay-system-type_wrapper other_pay-system-type" v-show="otherTypes">
        <div class="pay-system-type_item_wrapper  alfa_bank" :class="isActive('AB')" @click="selectPaymentType('AB')" data-pay-system="yandex_kassa">
          <div class="pay-system-type_item_content">Альфа-клик</div>
        </div>

      </div>
    </div>

    <div class="form_payment_action_pointer">
      <img class="form_payment_action_pointer__img" src="./arrow.png" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PaySystems',
    data: function() {
      return {
        payTypeActive: false,
        otherTypes: false
      }
    },
    props: {
      paymentType: String
    },
    computed: {
      isSafari() {
        return navigator.userAgent.indexOf('Version/') !== -1 && navigator.userAgent.indexOf('Safari/') !== -1;
      }
    },
    methods: {
      selectPaymentType(type) {
        this.$emit('selectPaymentType', type)
      },
      isActive(type) {
        return type === this.paymentType ? 'payTypeActive' : '';
      }
    }
  };
</script>

<style scoped>

  /*todo: сделать адаптивность в способах оплаты.*/

  .pay-system_choice {
    min-width: 460px;
    margin-top: 15px;
  }

  .pay-system-type__header {
    display: inline-block;
    margin-bottom: 10px;
  }

  .other_pay-system-type__header span {
    border-bottom: 1px dashed;
    cursor: pointer;
  }

  .pay-system-type_wrapper {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    margin-bottom: 20px;
  }

  .pay-system-type_wrapper .visa_mastercard {
    line-height: 1;
    width: auto;
  }

  .electronic_money {
    display: flex;
    justify-content: left;
  }

  .pay-system-type_item_wrapper {
    width: auto;
    margin-left: 10px;
    border-radius: 4px;
    border: 1px #f3bb1b solid;
    font-style: italic;
    cursor: pointer;
  }
  .pay-system-type_wrapper.electronic_money .pay-system-type_item_wrapper {
    width: 29%;
  }

  .pay-system-type_wrapper.other_pay-system-type .pay-system-type_item_wrapper {
    width: 29%;
  }
  .pay-system-type_item_wrapper:hover {
    border: 1px #3e3e3e solid;
  }
  .pay-system-type_item_wrapper:first-of-type {
    margin-left: 0;
  }

  .visa_mastercard .pay-system-type_item_content {
    padding-left: 130px;
    background-image: url(./yandex_kassa_visa_master_card.png);
    background-size: 105px;
    background-position: 12px 7px;
  }

  .cash .pay-system-type_item_content {
    padding-left: 48px;
    background-image: url(./yandex_kassa_ico_nal.png);
    background-size: 32px 24px;
  }

  .sberpay .pay-system-type_item_content {
    padding-left: 40px;
    background-image: url(./yandex_kassa_sberpay.png);
    background-size: 23px;
  }

  .yandex_kassa_webmoney .pay-system-type_item_content {
    background-image: url(./yandex_kassa_webmoney.png);
  }

  .qiwi .pay-system-type_item_content {
    background-image: url(./yandex_kassa_qiwi.png);
    background-size: 22px;
  }

  .yandex_dengi  .pay-system-type_item_content {
    background-image: url(./yandex_kassa_yandex_dengi.png);
    background-size: 22px;
  }

  .alfa_bank .pay-system-type_item_content {
    background-image: url(./yandex_kassa_alfa_bank.png);
    background-size: 18px 23px;
  }

  .pay-system-type_item_content {
    position: relative;
    background-repeat: no-repeat;
    background-position: 10px 6px;
    padding: 12px 10px 12px 40px;
  }

  .form_payment_action_pointer {
    display: flex;
  }
  .form_payment_action_pointer__img {
    position: relative;
    top: 5px;
    margin: 0 auto;
  }

  .payTypeActive  {
    line-height: 1;
    vertical-align: baseline;
    border-radius: 4px;
    border: 4px solid #f3bb1b;
    cursor: default;
    font-weight: bold;
  }

  .payTypeActive:hover {
    line-height: 1;
    vertical-align: baseline;
    border-radius: 4px;
    border: 4px solid #f3bb1b;
  }

</style>
